import { render } from "./RecentTests.vue?vue&type=template&id=0ad7fde4&scoped=true"
import script from "./RecentTests.vue?vue&type=script&lang=js"
export * from "./RecentTests.vue?vue&type=script&lang=js"

import "./RecentTests.vue?vue&type=style&index=0&id=0ad7fde4&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad7fde4"]])

export default __exports__